import { render, staticRenderFns } from "./CameraChildIntroductionPassVaccine.vue?vue&type=template&id=795d8395&scoped=true&"
import script from "./CameraChildIntroductionPassVaccine.vue?vue&type=script&lang=ts&"
export * from "./CameraChildIntroductionPassVaccine.vue?vue&type=script&lang=ts&"
import style0 from "./CameraChildIntroductionPassVaccine.vue?vue&type=style&index=0&id=795d8395&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795d8395",
  null
  
)

export default component.exports